import React from 'react';
import axios from 'axios';
import { api } from '@common/urls';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { articlePageProps } from "@kursk/utils/entitiesPages";

export default function ErrorPage() {
  return (
    <NotFoundPage />
  );
}

export async function getServerSideProps({ params, req }) {
  const { id } = params;
  try {
    const { data } = await axios.get(api.articles.getOne(id));
    if (data.article) {
      return articlePageProps(data.article, req, false, 'routes');
    }
  } catch (error) {
    return { props: {} };
  }
}
